export default {
    namespaced: true,

    state: {
        showNotFoundPage: false,
        showNoAccessPage: false,
        showGeneralErrorPage: false,
        showPageLoader: false,
        showSignupStep: {
            connecting: false,
            congratulations: false,
        },
        skipStep: {
            profile: false,
            registerPhysicians: false,
            isUserSetPassword: false,
            isUserJustRegistered: false,
        },
        adminNotAlreadyInvited: false,
    },

    mutations: {
        setShowPageLoader(state, flag) {
            state.showPageLoader = flag
        },

        setShowNotFoundPage(state, flag) {
            state.showNotFoundPage = flag
        },

        setShowNoAccessPage(state, flag) {
            state.showNoAccessPage = flag
        },

        setShowGeneralErrorPage(state, flag) {
            state.showGeneralErrorPage = flag
        },

        setAdminNotAlreadyInvited(state, flag) {
            state.adminNotAlreadyInvited = flag
        },

        setShowSignupStep(state, { step, flag }) {
            if (Object.getOwnPropertyNames(state.showSignupStep).some((key) => key === step)) {
                state.showSignupStep[step] = flag
            }
        },

        setSkipStep(state, { step, flag }) {
            if (Object.getOwnPropertyNames(state.skipStep).some((key) => key === step)) {
                state.skipStep[step] = flag
            }
        },
    },

    getters: {
        getShowPageLoader(state) {
            return state.showPageLoader
        },

        getShowNotFoundPage(state) {
            return state.showNotFoundPage
        },

        getShowNoAccessPage(state) {
            return state.showNoAccessPage
        },

        getShowGeneralErrorPage(state) {
            return state.showGeneralErrorPage
        },

        getShowSignupSteps(state) {
            return state.showSignupStep
        },

        getSkipStep(state) {
            return state.skipStep
        },

        getAdminNotAlreadyInvited(state) {
            return state.adminNotAlreadyInvited
        },
    },

    actions: {
        showPageLoader(Store) {
            Store.commit('setShowPageLoader', true)
        },

        hidePageLoader(Store) {
            Store.commit('setShowPageLoader', false)
        },

        showNotFoundPage(Store) {
            Store.commit('setShowNotFoundPage', true)
        },

        showNoAccessPage(Store) {
            Store.commit('setShowNoAccessPage', true)
        },

        showGeneralErrorPage(Store) {
            Store.commit('setShowGeneralErrorPage', true)
        },

        setAdminAlreadyInvited(Store) {
            Store.commit('setAdminNotAlreadyInvited', true)
        },

        switchOffShowingErrorPages(Store) {
            Store.commit('setShowNotFoundPage', false)
            Store.commit('setShowNoAccessPage', false)
            Store.commit('setShowGeneralErrorPage', false)
        },

        showSignupStepPage(Store, { step, flag }) {
            Store.commit('setShowSignupStep', { step, flag })
        },

        showSkipStep(Store, { step, flag }) {
            Store.commit('setSkipStep', { step, flag })
        },
    },
}
